import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { FIELD_TYPES } from "./boardingFormTemplate";

const GROUPS = [...new Set(FIELD_TYPES.map((f) => f.group))];

export default function FieldTypeSelector({ isOpen, onClose, onSelect }) {
  const [hovered, setHovered] = useState(null);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[75] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-4 max-h-[85vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h3 className="text-base font-semibold text-gray-800">Add Field</h3>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 text-gray-400 transition-colors"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto px-6 py-4 space-y-6">
          {GROUPS.map((group) => (
            <div key={group}>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">
                {group}
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {FIELD_TYPES.filter((f) => f.group === group).map((ft) => (
                  <button
                    key={ft.value}
                    type="button"
                    onClick={() => {
                      onSelect(ft);
                      onClose();
                    }}
                    onMouseEnter={() => setHovered(ft.value)}
                    onMouseLeave={() => setHovered(null)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-all ${
                      hovered === ft.value
                        ? "border-[#1B4582] bg-[#1B4582]/5 shadow-sm"
                        : "border-gray-200 hover:border-[#1B4582]/40"
                    }`}
                  >
                    <span
                      className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                        hovered === ft.value
                          ? "bg-[#1B4582] text-white"
                          : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {ft.icon}
                    </span>
                    <span
                      className={`text-sm font-medium leading-tight ${
                        hovered === ft.value ? "text-[#1B4582]" : "text-gray-700"
                      }`}
                    >
                      {ft.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
